import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield (-get-dynamic-var \"outletState\")}}")